export { default } from './MapQuickAccessDesktop';
